import Common from '@/service/common'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {
    query: null
  },
  mutations: {
    setQuery(state) {
      state.query = null
    },
    resetQuery(state) {
      state.query = null
    }
  },
  actions: {
    getvendornames(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getvendornames(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getzshomepages(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getzshomepages(payload), {
        type: 'list',
        success,
        fail
      })
    },
    gethscodes(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.gethscodes(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addhscode(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addhscode(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletehscode(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deletehscode(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatehscode(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updatehscode(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getportalmenutree2orgtype(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getportalmenutree2orgtype(payload), {
        type: 'info',
        success,
        fail
      })
    },
    resetpassword(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.resetpassword(payload), {
        type: 'action',
        success,
        fail
      })
    },
    modifypassword(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.modifypassword(payload), {
        type: 'action',
        success,
        fail
      })
    },
    uploadfile(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.uploadfile(payload), {
        type: 'info',
        success,
        fail
      })
    },
    uploadpdfandconver2image(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.uploadpdfandconver2image(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getordersources(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getordersources(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getaudits(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getaudits(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getstoppushedxsdds(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getstoppushedxsdds(payload), {
        type: 'list',
        success,
        fail
      })
    },
    deletestoppushedxsdd(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.deletestoppushedxsdd(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
